var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}
const inlineMenu = document.querySelector(".header__inline-menu");

const detailsItems = inlineMenu.querySelectorAll("details");

detailsItems.forEach((item) => {
  const ulElement = item.querySelector("ul");

  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);

    ulElement.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

$(document).ready(function () {
  $(".information-bar-top h3.custom-information-bar-info-block-heading").click(function(){
    $(this).parent(".information-bar-top").next("p").slideToggle();
  })
})
